import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './FeedbackSummaryDialog.css';

const StoryEndDialog = ({ isOpen, storyTitle, storyCoverImage, onReplay, onClose }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    if (!isOpen) return null;

    const handleReplay = () => {
        onReplay();
        onClose();
    }

    return (
        <div className="feedback-overlay">
            <div className="feedback-summary-dialog">
                <h2>{t('playStory.hopeYouLiked')}
                </h2>
                <button className="submit-btn feedback-summary-dialog-title-button" onClick={() => navigate("/login")}>
                    <i className="fa-solid fa-right-to-bracket"></i>
                    <span>{t('login.signIn')}</span>
                </button>                    
                <img src={storyCoverImage} alt={storyTitle} className="story-cover" />
                <h4>{storyTitle}</h4>
                <div className='dialog-buttons'>
                    <button className="submit-btn" onClick={handleReplay}>
                        <i className="fa-solid fa-arrow-rotate-left"></i>
                        <span>{t('playStory.replay')}</span>
                    </button>
                    <button className="cancel-btn" onClick={() => navigate("/")}>
                        <i className="fa-solid fa-house"></i>
                        <span>{t('playStory.home')}</span>
                    </button>
                    <button className="cancel-btn" onClick={onClose}>
                        <i className="fa-solid fa-xmark"></i>
                        <span>{t('playStory.close')}</span>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default StoryEndDialog;